// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".BirthDateModal{max-width:400px}.BirthDatePicker{max-height:500px;height:250px;position:relative}.BirthDatePicker .SelectorColumn{display:flex;flex-direction:column;justify-content:flex-start;align-items:center;overflow-y:scroll;max-height:100%;padding:8px}.BirthDatePicker .SelectorColumn .selected{transform:scale(1.4);color:#000 !important;padding:2px}\n", ""]);
// Exports
module.exports = exports;
